// Cutover to the property-level meter register.
//
// Reports for October 2026 onwards read their meters from the property's
// register and store readings against them. Reports for September 2026 and
// earlier keep the legacy shape untouched: [name, reading, serial] triples in
// `reading_fields`, with photos in the fixed image_5..image_14 slots.
//
// Keyed off the REPORTING PERIOD (month/year on the report), not when the
// record was created -- so a September report filed late in October is still
// legacy.
//
// Must behave identically to usesNewMeters() in gg-be/config/meter.js. Import
// this rather than re-testing the dates inline: the check is needed in the
// create form, the edit form, and both PDF templates, and four copies will
// drift.
export const METER_CUTOVER_YEAR = 2026;
export const METER_CUTOVER_MONTH = 10; // October; `month` is 1-12

/**
 * Does this report use the new property-level meter register?
 *
 * Reports spanning a range (month..month_end) are judged on `month`, the start
 * of the period, so a September-October report stays legacy.
 *
 * Defaults to false when the period is missing or unparseable: legacy is the
 * safe fallback, since it renders from data already on the report row rather
 * than expecting reading rows that will not exist.
 *
 * @param {{month: number|string, year: number|string}} report
 * @returns {boolean}
 */
export function usesNewMeters(report) {
  const year = Number(report?.year);
  const month = Number(report?.month);

  if (!Number.isFinite(year) || !Number.isFinite(month)) return false;
  if (year <= 0 || month <= 0) return false;

  return (
    year > METER_CUTOVER_YEAR ||
    (year === METER_CUTOVER_YEAR && month >= METER_CUTOVER_MONTH)
  );
}
